import styled from 'styled-components';

export const OrderList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 8px 0;
`;

export const OrderItem = styled.div`
  cursor: pointer;
  padding: 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
`;

export const OrderName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #314158;
`;

export const OrderMeta = styled.div`
  font-size: 12px;
  color: #6c757d;
  margin-top: 4px;
`;
